/**
 * A config containing properties for sort
 */
var SortConfig = /** @class */ (function () {
    function SortConfig() {
    }
    return SortConfig;
}());
export { SortConfig };
//# sourceMappingURL=sort-config.js.map